<template>
  <div class="hiddenManage">
    <tree-box title="租户管理" @sendID="getID" showTree isrent>
      <template slot="message">
        <div class="search-choose">


          <el-select
            v-model="nameType"
            style="width: 200px; margin-right: 12px"
            placeholder="请选择"
            size="large"
          >
            <el-option
              v-for="(item, index) in typeList"
              :key="index"
              :label="item.name"
              :value="item.type"
            ></el-option>
          </el-select>


          <el-input
            style="width: 200px"
            v-model="dataname"
            type="text"
            placeholder="请输入"
            size="large"
          ></el-input>
          <el-button   type="primary" @click="searchdata()" style="margin-left: 20px;">搜索</el-button>
          <el-button @click="refresh" style="margin-left: 20px;">重置</el-button>
          <el-button
            style="float: right;"
            type="primary"
            size="large"
            @click="addrent()"
          >新增</el-button>
          <el-button
          style="float: right;"
            size="large"
            @click="nowType()"
          >现有归类</el-button
          >

        </div>
        <div class="table">
          <el-table v-loading="loading" :data="tableList">
            <el-table-column

              prop="tenantName"
              align="center"
              label="租户名称"
            ></el-table-column>
            <el-table-column
              prop="districtName"
              align="center"
              label="所属区域"
            ></el-table-column>
            <el-table-column prop="phone" label="租户手机号"></el-table-column>
            <el-table-column prop="loginName" label="租户账号名"></el-table-column>
            <el-table-column
              prop="state"
              align="center"
              label="启用状态"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.state == false"> 停用 </span>
                <span v-if="scope.row.state == true"> 启用 </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <span class="tableBtn" @click="showDialog(scope.row)">编辑</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              @current-change="pageChange"
              background
              :current-page="page"
              :page-size="sizePage"
              layout="total,prev, pager, next, jumper"
              :total="totalSum"
            >
            </el-pagination>
          </div>
        </div>

        <!--        <div v-if="!deptId" class="tip">-->
        <!--          <img src="../img/jiantou.png" /><span style="margin-left: 12px"-->
        <!--            >请点击右侧选择单位</span-->
        <!--          >-->
        <!--        </div>-->
      </template>
    </tree-box>

    <el-dialog
      :visible.sync="status"
      width="30%"
      title="新增租户"
      :close-on-click-modal="false"
    >
      <div class="dialog__main">

        <el-form :model="form" ref="form" class="form" :rules="rules">
          <el-form-item
            label="租户名称"
            prop="tenantName"
            :label-width="formLabelWidth"
          >
            <el-input size="large" v-model="form.tenantName"></el-input>
          </el-form-item>
          <el-form-item
            label="租户手机号"
            prop="phone"
            :label-width="formLabelWidth"
          >
            <el-input size="large" v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item
            label="所属区域"
            prop="districtName"
            :label-width="formLabelWidth"
          >
            <el-cascader
              style="width: 100%"
              v-model="form.districtName"
              :show-all-levels="false"
              :options="orgTree"
              size="large"
              :props="{ value: 'districtId', label: 'name', checkStrictly: true,emitPath: false }"
            ></el-cascader>
          </el-form-item>

          <el-form-item
            label="账号名"
            prop="loginName"
            :label-width="formLabelWidth"
          >
            <el-input size="large" v-model="form.loginName"></el-input>
          </el-form-item>
          <el-form-item
            label="密码"
            prop="pwd"
            :label-width="formLabelWidth"
          >
            <el-input size="large" v-model="form.pwd"></el-input>
          </el-form-item>
          <el-form-item
            label="启用状态"
            prop="state"
            :label-width="formLabelWidth"
          >
            <el-switch
              v-model="form.state"
              active-color="#13ce66"
              inactive-color="#ff4949"
              size="large"
              :active-value="true"
              :inactive-value="false"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="status = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialog"
      width="30%"
      title="编辑租户"
      :close-on-click-modal="false"
    >
      <div class="dialog__main">

        <el-form :model="form" ref="form" class="form" :rules="rules">
          <el-form-item
            label="租户名称"
            prop="tenantName"
            :label-width="formLabelWidth"
          >
            <el-input size="large" v-model="form.tenantName"></el-input>
          </el-form-item>
          <el-form-item
            label="租户手机号"
            prop="phone"
            :label-width="formLabelWidth"
          >
            <el-input size="large" v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item
            label="所属区域"
            prop="districtName"
            :label-width="formLabelWidth"
          >
            <el-cascader
              style="width: 100%"
              v-model="form.districtName"
              :show-all-levels="false"
              :options="orgTree"
              size="large"
              :props="{ value: 'districtId', label: 'name', checkStrictly: true,emitPath: false }"
            ></el-cascader>
          </el-form-item>

          <el-form-item
            label="账号名"
            prop="loginName"
            :label-width="formLabelWidth"
          >
            <el-input size="large" v-model="form.loginName"></el-input>
          </el-form-item>
          <el-form-item
            label="密码"
            prop="pwd"
            :label-width="formLabelWidth"
          >
            <el-input size="large" v-model="form.pwd"></el-input>
          </el-form-item>
          <el-form-item
            label="启用状态"
            prop="state"
            :label-width="formLabelWidth"
          >
            <el-switch
              v-model="form.state"
              active-color="#13ce66"
              inactive-color="#ff4949"
              size="large"
              :active-value="true"
              :inactive-value="false"
            >
            </el-switch>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 定</el-button>
        <el-button @click="status = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "../../../utils/Axios";
import Axios2 from "../../../utils/Axios2";
import treeBox from "./components/treeBox";
import qs from "qs";
export default {
  name: "hiddenManger",
  components: { treeBox },
  data() {
    return {
      page: 1,
      sizePage: 10,
      totalSum: 0,
      riskLevel: [],
      status:false,
      id: null,
      level: null,
      dataname: null,
      nameType: "tenantName",
      deptId: 15,
      tableList: [],
      loading: false,
      dialog: false,
      orgTree:[],
      formLabelWidth: "90px",
      form:{
        tenantName:"",
        phone:"",
        loginName:"",
        districtName:"",
        state:true,
        pwd:"",
      },
      rules: {
        phone: [
          { required: false, trigger: "blur" },
          // 这个只能验证手机号
          // { pattern:/^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/, message: "请输入合法手机号", trigger: "blur" }
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
            message: "请输入合法手机号/电话号",
            trigger: "blur",
          },
        ],
        tenantName: [
          { required: true, trigger: "blur" },
      ],
        loginName: [
          { required: true, trigger: "blur" },
        ],
        districtName: [
          { required: true, trigger: "blur" },
        ],
        pwd: [
          { required: true, trigger: "blur" },
        ],
        state: [
          { required: true, trigger: "blur" },
        ],
      },
      typeList:[
        {
          name:"租户名称",
          type:"tenantName"
        },
        {
          name:"手机号",
          type:"phone"
        },
        {
          name:"租户管理员",
          type:"loginName"
        },
      ]
    };
  },
  methods: {
    searchdata(){
      this.queryTableList()
    },
    confirm() {
      let that=this
      this.$refs.form.validate((va) => {

        const param = {};
        param.method = "post";
        param.url = "/system/web/v2/tenant/add";
        param.data = {
          districtId:this.form.districtName,
          tenantName:this.form.tenantName,
          phone:this.form.phone,
          loginName:this.form.loginName,
          pwd:this.form.pwd,
          state:this.form.state,
        };
        Axios2.ajax(param).then((res) => {
          if (res.resultCode == 0) {
            this.$message.success("新增成功！");
            this.status=false
            this.queryTableList();

          }else {
            this.$message.warning(res.resultMessage);
          }
        });
      });
    },
    getOrgTree2() {
      const param = {};
      param.method = "post";
      param.url = "/system/web/v2/district/tree";
      param.datas = {};
      Axios2.ajax(param).then((res) => {
        if (res.data) {
          this.orgTree = res.data;

        }
      });
    },
    pageChange(){

    },
    addrent(){
this.status=true
      this.form={

      }
    },
    nowType(){

    },
    refresh(){

    },
    getID(id) {
      this.deptId = id;

      this.queryTableList();
    },
    showDialog(row) {
      console.log(row)
      this.dialog = true;
      this.id = row.id;
      this.form = row;
      this.queryTableList();
    },
    confirmEdit() {
      Axios.ajax({
        url: "/riskManage/edit",
        method: "post",
        data: {
          id: this.id,
          riskLevel: this.level,
        },
      }).then((res) => {
        if (res.resultCode == 0) {
          this.$message.success("修改成功！");
        } else {
          this.$message.warning("修改失败！");
        }

        this.dialog = false;
        this.queryTableList();
      });
    },
    queryTableList() {
      this.loading = true;
      const params = {
        url: "/system/web/v2/tenant/page",
        method: "post",
        data: {
          districtId: this.deptId,
          tenantName: "",
          phone:"",
          loginName: "",
          pageNum: this.page,
          showNum: this.sizePage,
        },
      };
      if(this.nameType=='tenantName'){
        params.data.tenantName=this.dataname
      }else if(this.nameType=='phone'){
        params.data.phone=this.dataname
      }else if(this.nameType=='loginName'){
        params.data.loginName=this.dataname
      }
      Axios2.ajax(params).then(({ data }) => {

        this.loading = false;
        this.totalNum = data.totalNum;
        this.tableList = data.dataList;
      });
    },

    queryRiskLevels() {
      Axios.ajax({
        url: "/riskManage/allRiskLevels",
        method: "get",
      }).then(({ data }) => {
        this.riskLevel = data.map((item) => {
          return {
            label: item.levelName,
            value: item.sysRiskLevel,
          };
        });
      });
    },
  },
  mounted() {
    this.queryTableList();
    this.getOrgTree2();
  },
  watch: {
    nameType() {
      this.dataname=""
    },


  },
};
</script>

<style lang="less" scoped>
.hiddenManage {
  .page {
    position: absolute;
    bottom: 0;
    right: 50px;
    margin-bottom: 36px;
  }
  .message {
    h3 {
      padding: 0 10px;
      border-left: 2px solid #2a62ff;
    }
    .table {
      height: 90%;
      overflow: auto;
      padding-top: 32px;
      .tableBtn {
        cursor: pointer;
        color: #2a62ff;
      }
    }
    .tip {
      width: 100%;
      text-align: center;
      padding: 20%;
      color: #7d879f;
      font-size: 16px;
    }
    .btn-group {
      margin-top: 44px;
    }
    .btn-group button:first-child {
      margin-right: 40px !important;
    }
  }
  .dialog {
    font-size: 14px;
    text-align: center;
    label {
      margin-right: 12px;
    }
  }
}
</style>
